export default "/images/vendor/flag-icon-css/flags/1x1/gr.svg?d0a42f6b9252659b162526cad0c69667";